<div class="generic-tag-filters">
  <!-- Add Filter Button and Dropdown Panel -->
  <div class="add-filter-container">
    <button class="btn btn-sm btn-outline-primary add-filter-btn" 
            (click)="openFilterPanel()" 
            [disabled]="availableFilters.length === 0">
      <i class="fas fa-filter"></i> Add Filter
    </button>

    <!-- Unified filter selection and value panel -->
    <div class="filter-panel" *ngIf="showFilterPanel">
      <div class="filter-panel-header">
        <div>
          <h6>Add Filter</h6>
          <span>Choose a field, then select its value.</span>
        </div>
        <i class="fas fa-times close-panel" (click)="closeFilterPanel()"></i>
      </div>

      <div class="filter-panel-body">
        <div class="filter-picker-column">
          <label class="column-label">Filter field</label>
          <div class="filter-field-search">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control" [(ngModel)]="filterSearchText"
              placeholder="Search filters..." />
          </div>
          <div class="available-filter-list">
          <div class="available-filter" 
               *ngFor="let config of filteredAvailableFilters"
               [class.selected]="selectedFilterConfig === config"
               (click)="onFilterSelected(config)">
            <i [class]="config.iconClass || 'fas fa-filter'" *ngIf="config.iconClass"></i>
            <span>{{ config.label }}</span>
            <i class="fa fa-chevron-right selection-chevron"></i>
          </div>
          <div class="no-filters" *ngIf="availableFilters.length === 0">
            All filters are currently active
          </div>
          <div class="no-filters" *ngIf="availableFilters.length > 0 && filteredAvailableFilters.length === 0">
            No filters match your search
          </div>
        </div>
      </div>

        <div class="filter-value-column">
          <ng-container *ngIf="selectedFilterConfig; else selectFilterPrompt">
          <label class="column-label">{{ selectedFilterConfig.label }}</label>
          <div class="filter-editor-control">
          <!-- Dropdown -->
          <div *ngIf="selectedFilterConfig.type === FilterType.Dropdown">
            <select class="form-control" 
                    *ngIf="selectedFilterConfig.options && !selectedFilterConfig.lookupId"
                    [(ngModel)]="tempFilterValue">
              <option [ngValue]="null">{{ selectedFilterConfig.placeholder || 'Select...' }}</option>
              <option *ngFor="let option of selectedFilterConfig.options" [ngValue]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Multi-Select -->
          <div *ngIf="selectedFilterConfig.type === FilterType.MultiSelect">
            <p-multiSelect 
              *ngIf="selectedFilterConfig.options && !selectedFilterConfig.lookupId"
              [(ngModel)]="tempFilterValue"
              [options]="selectedFilterConfig.options"
              optionLabel="label"
              optionValue="value"
              [placeholder]="selectedFilterConfig.placeholder || 'Select...'">
            </p-multiSelect>
          </div>

          <div class="inline-lookup-selector" *ngIf="selectedFilterConfig.lookupId
            && (selectedFilterConfig.type === FilterType.Dropdown
              || selectedFilterConfig.type === FilterType.MultiSelect)">
            <div class="lookup-option-search">
              <i class="fa fa-search"></i>
              <input type="text" class="form-control" [(ngModel)]="lookupOptionSearchText"
                placeholder="Search {{ selectedFilterConfig.label | lowercase }}..." />
            </div>
            <div class="lookup-options" *ngIf="!lookupOptionsLoading && !lookupOptionsError">
              <button type="button" class="lookup-option" *ngFor="let option of filteredLookupOptions"
                [class.selected]="isLookupOptionSelected(option)" (click)="selectLookupOption(option)">
                <i class="fa"
                  [class.fa-check-square]="selectedFilterConfig.type === FilterType.MultiSelect && isLookupOptionSelected(option)"
                  [class.fa-square-o]="selectedFilterConfig.type === FilterType.MultiSelect && !isLookupOptionSelected(option)"
                  [class.fa-dot-circle-o]="selectedFilterConfig.type === FilterType.Dropdown && isLookupOptionSelected(option)"
                  [class.fa-circle-o]="selectedFilterConfig.type === FilterType.Dropdown && !isLookupOptionSelected(option)"></i>
                <span>{{ option.Display }}</span>
              </button>
              <div class="lookup-options-message" *ngIf="lookupOptions.length === 0">No values are available.</div>
              <div class="lookup-options-message" *ngIf="lookupOptions.length > 0 && filteredLookupOptions.length === 0">
                No values match your search.
              </div>
            </div>
            <div class="lookup-options-message" *ngIf="lookupOptionsLoading">
              <i class="fa fa-spinner fa-spin"></i> Loading values...
            </div>
            <div class="alert alert-danger lookup-options-error" *ngIf="lookupOptionsError">
              {{ lookupOptionsError }}
            </div>
          </div>

          <!-- Date Range -->
          <div *ngIf="selectedFilterConfig.type === FilterType.ReportDatePeriod">
            <label class="small-label">Period</label>
            <select class="form-control" [(ngModel)]="tempReportDateMode">
              <option value="rollingDays">Last number of days</option>
              <option value="currentMonth">Current month</option>
              <option value="previousMonth">Previous month</option>
              <option value="currentQuarter">Current quarter</option>
              <option value="previousQuarter">Previous quarter</option>
              <option value="currentYear">Current year</option>
              <option value="previousYear">Previous year</option>
              <option value="exactRange">Custom dates</option>
            </select>
            <div class="mt-2" *ngIf="tempReportDateMode === 'rollingDays'">
              <label class="small-label">Days</label>
              <input class="form-control" type="number" min="1" max="3650" [(ngModel)]="tempReportDateDays" />
            </div>
            <div class="mt-2" *ngIf="tempReportDateMode === 'exactRange'">
              <dw-date-range-input [(startDate)]="tempDateRangeStart" [(endDate)]="tempDateRangeEnd"></dw-date-range-input>
            </div>
          </div>

          <!-- Date Range -->
          <div *ngIf="selectedFilterConfig.type === FilterType.DateRange">
            <label class="small-label">Date Range</label>
           <dw-date-range-input [(startDate)]="tempDateRangeStart" [(endDate)]="tempDateRangeEnd"></dw-date-range-input>
          </div>

          <!-- Date Picker -->
          <div *ngIf="selectedFilterConfig.type === FilterType.DatePicker">
            <p-calendar 
              [(ngModel)]="tempFilterValue"
              dateFormat="mm/dd/yy"
              [showIcon]="true">
            </p-calendar>
          </div>

          <!-- Toggle -->
          <div *ngIf="selectedFilterConfig.type === FilterType.Toggle">
            <p-inputSwitch [(ngModel)]="tempFilterValue"></p-inputSwitch>
            <span class="ml-2">{{ tempFilterValue ? 'Enabled' : 'Disabled' }}</span>
          </div>

          <!-- Text Input -->
          <div *ngIf="selectedFilterConfig.type === FilterType.TextInput">
            <input type="text" 
                   class="form-control" 
                   [(ngModel)]="tempFilterValue"
                   [placeholder]="selectedFilterConfig.placeholder || 'Enter value...'">
          </div>
          </div>

          <div class="filter-actions">
            <button class="btn btn-sm btn-secondary mr-2" (click)="closeFilterPanel()">Cancel</button>
            <button class="btn btn-sm btn-primary" (click)="applySelectedFilter()">Apply</button>
          </div>
          </ng-container>

          <ng-template #selectFilterPrompt>
            <div class="filter-selection-prompt">
              <i class="fa fa-filter"></i>
              <strong>Select a filter field</strong>
              <span>Its selection options will appear here.</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Active Filter Tags -->
  <div class="filter-tags-container" *ngIf="activeFilters.length > 0">
    <div class="filter-tag" *ngFor="let filter of activeFilters">
      <span class="filter-label">{{ filter.displayLabel }}:</span>
      <span class="filter-value" *ngIf="!filter.displayLoading">{{ filter.displayValue }}</span>
      <span class="filter-value filter-value-loading" *ngIf="filter.displayLoading"
        title="Loading filter value" aria-label="Loading filter value">
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      </span>
      <i class="fas fa-times filter-remove" (click)="removeFilter(filter)" title="Remove filter"></i>
    </div>
    <button class="btn btn-sm btn-link clear-all-btn" (click)="clearAllFilters()" *ngIf="activeFilters.length > 1">
      Clear All
    </button>
  </div>

</div>
